import React from 'react';
import Link from 'next/link';
import styles from './styles.module.scss';
import { Icon } from '../Icon';
import color from '../../styles/colors/index.module.scss';
import { constructClassName } from '../../utils/constructClassName';

interface Props {
  pathElements: {
    title: string;
    slug: string;
  }[];
  hideLastOnMobile?: boolean;
}

export const Breadcrumb: React.FC<Props> = ({
  pathElements,
  hideLastOnMobile = true,
}) => (
  <div className={styles.container}>
    {pathElements.map((pathElement, index) => (
      <span
        key={pathElement.slug}
        className={constructClassName([
          styles.breadcrumb,
          hideLastOnMobile && styles.hideLastOnMobile,
        ])}
      >
        {index > 0 && (
          <React.Fragment>
            {' '}
            <Icon
              icon="chevronRightClassicLight"
              size={8}
              fill={color.grey}
            />
            {' '}
          </React.Fragment>
        )}
        <Link
          href={`/${pathElements.slice(0, index + 1).filter((pe) => pe.slug !== '').map((pe) => pe.slug).join('/')}`}
          className={styles.breadcrumbLink}
        >
          {pathElement.title}
        </Link>
      </span>
    ))}
  </div>
);
